/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type useLiveNotificationsPollingLocal = {
    readonly notificationCount: number | null;
    readonly notificationsPollRate: number;
    readonly hasNewNotifications: boolean | null;
    readonly " $refType": "useLiveNotificationsPollingLocal";
};
export type useLiveNotificationsPollingLocal$data = useLiveNotificationsPollingLocal;
export type useLiveNotificationsPollingLocal$key = {
    readonly " $data"?: useLiveNotificationsPollingLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"useLiveNotificationsPollingLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useLiveNotificationsPollingLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "notificationCount",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "notificationsPollRate",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNewNotifications",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = 'e7b3fed1610189e0689216b4251e0d36';
export default node;
